import { Box, Typography, styled } from "@mui/material";

export const OrderBox = styled(Box)({
  background: "#ffffff",
  padding: "14px 24px",
  borderRadius: "8px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  minHeight: "60px",
});

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: "13px",
  fontWeight: 500,
  fontFamily: "Roboto",
  color: "#332233",
}));
export const Text = styled(Typography)(({ theme }) => ({
  fontSize: "15px",
  fontWeight: 400,
  fontFamily: "Roboto",
  color: "#737373",
}));

export const SubTitle = styled(Typography)(({ theme }) => ({
  fontSize: "13px",
  fontWeight: 400,
  fontFamily: "Roboto",
  color: "#AFAFAF",
}));
export const TextIcrement = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 500,
  fontFamily: "Roboto",
  color: "#332233",
}));

export const ImgBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#ffffff",
  borderRadius: "6px",
  height: "60px",
  width: "60px",
}));
export const IncrementBox = styled(Box)(({ theme }) => ({
  borderRadius: "50px",
  background: "#ACFFCD !important",
  color: "#323232",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "91px",
  height: "32px",
  paddingLeft: "16px",
  paddingRight: "16px",
}));
export const ListBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  spacing: "8px",
  flexWrap: "wrap",
  width: "95%",
  gap: "8px",
  justifyContent: "space-between",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    justifyContent: "center",
  },
}));

export const IndexItemBox = styled(Box)({
  background: "#F6F6F6",
  padding: "10px 16px",
  borderRadius: "8px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});
